import { ReactNode } from "react";
import { colors } from "constants/colors";
import { StyledText } from "styles/Text";
import * as RevealCardStyles from "./RevealCard.styles";

// 임밍아웃 이미지 카드
const RevealCard = ({
  imageUrl,
  date,
  children,
  isCapture,
}: {
  imageUrl: string;
  date: string;
  children?: ReactNode;
  isCapture?: boolean;
}) => (
  <RevealCardStyles.StyledCard $isCapture={isCapture}>
    <RevealCardStyles.StyledPhotoBox>
      <RevealCardStyles.StyledPhotoInner>
        <RevealCardStyles.StyledPhotoImg src={imageUrl} alt="capture image" />
        <StyledText.Sub12 color={colors.gray} $textAlign="right">
          {date}
        </StyledText.Sub12>
      </RevealCardStyles.StyledPhotoInner>
    </RevealCardStyles.StyledPhotoBox>

    <StyledText.DisplayM24
      as="p"
      fontWeight="500"
      $textAlign="center"
      color={colors.black}
      style={{ whiteSpace: "pre-line" }}
    >
      {"아기 천사가 찾아왔어요\n열달후에 만나요!"}
    </StyledText.DisplayM24>

    <RevealCardStyles.StyledFlagImg
      src={require("assets/images/img_card_flag.png")}
      alt="flag image"
    />

    {children}
  </RevealCardStyles.StyledCard>
);

export default RevealCard;
